import { render, staticRenderFns } from "./batchImportPolicy.vue?vue&type=template&id=5ef1365a"
import script from "./batchImportPolicy.vue?vue&type=script&lang=js"
export * from "./batchImportPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports